export default "__VITE_ASSET__7ca76002__"